// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"AboutDialog_subtitle__3AXPt"};